<template>
  <div class="menu-btns" v-click-outside="hideMenu">
    <div
      class="menu-btns-toggle officehome-gnb-home"
      :class="[isMenuVisible ? 'active' : '']"
      @click="toggleMenu"
      v-show="this.localMenuName"
    >
      <span class="btn-main" v-text="localMenuName"></span>
      <font-awesome-icon :icon="['fas', 'caret-down']" />
    </div>

    <div v-if="isTestOffice && isLimittedService" class="test-office-info">
      <i class="gis gi-exclam-circle" @mouseover="TogglenfoText" @mouseleave="TogglenfoText"></i>
      <div class="arrow_box" v-show="showMessage">{{ testOfficeWarnMessage }}</div>
    </div>

    <transition name="fade">
      <div v-if="isMenuVisible">
        <MenuBasic
          v-show="!isMenuDetailVisible"
          :domain="domain"
          :is-menu-detail-visible="isMenuDetailVisible"
          :menu-info-list="menuInfoList"
          :intranet-list="intranetList"
          :bookmark-list="bookmarkList"
          :group-list="groupList"
          :my-plus-app-list="myPlusAppList"
          @set-menu-detail-visible="setMenuDetailVisible"
          @set-bookmark-order-setting-visible="setIsBookmarkOrderSettingVisible"
          @click-plus-app="clickPlusApp"
          @click-intranet="clickIntranet"
        />

        <MenuDetail
          v-show="isMenuDetailVisible"
          :is-menu-order-setting-visible="isMenuOrderSettingVisible"
          :is-setting-visible="isSettingVisible"
          :domain="domain"
          :menu-info-list="menuInfoList"
          :intranet-list="intranetList"
          :bookmark-list="bookmarkList"
          :group-list="groupList"
          :my-plus-app-list="myPlusAppList"
          @hide-menu-detail-visible="setMenuDetailVisible"
          @set-menu-visible="setMenuVisible"
          @set-intranet-visible="setIntranetVisible"
          @set-bookmark-visible="setBookmarkVisible"
          @set-group-visible="setGroupVisible"
          @set-my-plus-app-visible="setMyPlusAppVisible"
          @toggle-is-setting-visible="toggleIsSettingVisible"
          @set-bookmark-order-setting-visible="setIsBookmarkOrderSettingVisible"
          @set-menu-order-setting-visible="setIsMenuOrderSettingVisible"
          @click-plus-app="clickPlusApp"
          @click-intranet="clickIntranet"
        />
      </div>
    </transition>

    <BookmarkOrderSetting
      v-if="isBookmarkOrderSettingVisible"
      :bookmark-list="bookmarkList"
      :bookmark-add-visible-type="bookmarkAddVisibleType"
      @set-bookmark-order-setting-visible="setIsBookmarkOrderSettingVisible"
      @create-bookmark="createBookmark"
      @modify-bookmark="modifyBookmark"
      @remove-bookmark="removeBookmark"
      @modify-bookmark-order="modifyBookmarkOrder"
      @set-bookmark-add-visible-type="setBookmarkAddVisibleType"
    />

    <MenuOrderSetting
      v-if="isMenuOrderSettingVisible"
      :menu-info-list="menuInfoList"
      @modify-menu-order="modifyMenuOrder"
      @set-is-menu-order-setting-visible="setIsMenuOrderSettingVisible"
    />

    <PlusAppPrivacyCheckDialog
      v-if="isShowPlusAppPrivacyDialog"
      :selectedPlusApp="selectedPlusApp"
      :privacyDocList="privacyDocList"
      @close-plus-privacy-check-dialog="closePlusPrivacyCheckDialog"
      @click-accept-plus-app-privacy="clickAcceptPlusAppPrivacy"
    />

    <BookmarkIntranetPrivacyCheckDialog
      v-if="isShowIntranetBookmarkPrivacyDialog"
      :selectedIntranetBookmark="selectedIntranetBookmark"
      :privacyDocList="privacyDocList"
      @click-accept-intranet-bookmark-privacy="clickAcceptIntranetBookmarkPrivacy"
      @close-intranet-bookmark-privacy-check-dialog="closeIntranetBookmarkPrivacyCheckDialog"
    />
  </div>
</template>

<script>
import MenuBasic from './MenuBasic';
import MenuDetail from './MenuDetail';
import BookmarkOrderSetting from '../Bookmark/BookmarkOrderSetting';
import MenuOrderSetting from './MenuOrderSetting';
import { mapState } from 'vuex';
import PlusAppPrivacyCheckDialog from '../PrivacyCheck/PlusAppPrivacyCheckDialog.vue';
import BookmarkIntranetPrivacyCheckDialog from '../PrivacyCheck/BookmarkIntranetPrivacyCheckDialog.vue';

export default {
  name: 'Menu',
  components: {
    MenuBasic,
    MenuDetail,
    BookmarkOrderSetting,
    MenuOrderSetting,
    PlusAppPrivacyCheckDialog,
    BookmarkIntranetPrivacyCheckDialog,
  },
  props: {
    isMenuVisible: {
      type: Boolean,
      required: true,
    },
    isMenuDetailVisible: {
      type: Boolean,
      required: true,
    },
    isBookmarkOrderSettingVisible: {
      type: Boolean,
      required: true,
    },
    bookmarkAddVisibleType: {
      type: Number,
      required: true,
    },
    isShowPlusAppPrivacyDialog: {
      type: Boolean,
      required: true,
    },
    domain: {
      type: String,
    },
    officeAccountInfo: {
      type: Object,
      required: true,
    },
    menuInfoList: {
      type: Array,
      required: true,
    },
    intranetList: {
      type: Array,
      required: true,
    },
    bookmarkList: {
      type: Array,
      required: true,
    },
    groupList: {
      type: Array,
      required: true,
    },
    myPlusAppList: {
      type: Array,
      required: true,
    },
    menuName: {
      type: String,
    },
    selectedPlusApp: {
      type: Object,
    },
    privacyDocList: {
      type: Array,
    },
    selectedIntranetBookmark: {
      type: Object,
    },
    isShowIntranetBookmarkPrivacyDialog: {
      type: Boolean,
    },
  },
  data() {
    return {
      showMessage: false,
      isSettingVisible: false,
      isMenuOrderSettingVisible: false,
    };
  },
  computed: {
    ...mapState({
      cacheUserInfo: (state) => state.cache.userInfo,
    }),
    getCurrentService() {
      return window.location.hostname.split('.')[0];
    },

    isLimittedService() {
      const service = this.getCurrentService;
      return service === 'team-mail' || service === 'mail' || service === 'bill';
    },

    isTestOffice() {
      //! 백앤드 작업 전까지 무기한 보류
      return false;
      //return this.cacheUserInfo.office.office_id === 'gabia.biz';
    },
    testOfficeWarnMessage() {
      const service = this.getCurrentService;
      if (service === 'team-mail' || service === 'mail') {
        return '하이웍스 데모 체험 오피스는 안전한 보안을 위해 외부 메일 송수신이 제한됩니다.';
      } else {
        return '하이웍스 데모 체험 오피스는 세금계산서 발급 및 국세청 전송이 제한됩니다.';
      }
    },
    localMenuName() {
      // attribute로 들어온 menuName이 있을경우 모든 로직 무시하고 전달받은 menuName 사용
      if (this.menuName) {
        return this.$t(this.menuName);
      }

      let menuType = null;
      let menuName = null;

      if (location.pathname.includes('/mail/')) {
        menuType = 'MAIL_LINK';
      } else if (location.pathname.includes('/officemail/')) {
        menuType = 'MAIL_LINK';
      } else if (location.pathname.includes('/board/')) {
        menuType = 'BOARD_LINK';
      } else if (location.pathname.includes('/bbs/')) {
        menuType = 'BOARD_LINK';
      } else if (location.pathname.includes('/ea/')) {
        menuType = 'EA_LINK';
      } else if (location.pathname.includes('/org/')) {
        menuType = 'ORG_LINK';
      } else if (location.pathname.includes('/insa/')) {
        menuType = 'ORG_LINK';
      } else if (location.pathname.includes('/sms/')) {
        menuType = 'SMS_LINK';
      } else if (location.pathname.includes('/webhard/')) {
        menuType = 'WEBHARD_LINK';
      } else if (location.pathname.includes('/addr')) {
        menuType = 'ADDR_LINK';
      } else if (location.pathname.includes('/shared/')) {
        // 구 공용메일
        menuType = 'SHARED_LINK';
      } else if (location.pathname.includes('/bill')) {
        menuType = 'BILL_LINK';
      } else if (location.pathname.includes('/schedule')) {
        menuType = 'SCHEDULE_LINK';
      } else if (location.pathname.includes('/approval/')) {
        menuType = 'EA_LINK';
      } else if (location.pathname.includes('/booking/')) {
        menuType = 'BOOKING_LINK';
      } else if (location.pathname.includes('/store')) {
        menuType = 'STORE_LINK';
      } else if (location.pathname.includes('/common/security')) {
        menuType = 'ADMIN_LINK';
      } else if (location.pathname.includes('/h_admin/')) {
        menuType = 'ADMIN_LINK';
      } else if (location.pathname.includes('/common/security/')) {
        menuType = 'ADMIN_LINK';
      } else if (location.pathname.includes('/point/')) {
        menuType = 'ADMIN_LINK';
      } else if (location.pathname.includes('/accounting/')) {
        menuType = 'ACCOUNTING_LINK';
      } else if (location.pathname.includes('/group/')) {
        menuType = 'GROUP_LINK';
      }

      if (!menuType) {
        if (location.pathname.includes('/common/office_main')) {
          menuName = this.$t('OFFICE_HOME');
        } else if (location.pathname.includes('/point/')) {
          menuName = this.$t('POINT_MANAGE');
        } else if (location.pathname.includes('/partner/payzon/')) {
          menuName = this.$t('PAYZON_LINK');
        } else if (location.pathname.includes('/apps/')) {
          menuName = this.$t('API_MANAGE');
        } else if (location.pathname.includes('/mypage/manager/')) {
          menuName = this.$t('PERSONAL_MANAGE');
        } else if (location.pathname.includes('/')) {
          menuName = this.$t('OFFICE_HOME');
        } else {
          menuName = this.$t('MENU_NAME');
        }
      } else {
        menuName = this.$t(menuType);
      }

      return menuName;
    },
  },
  watch: {
    isMenuDetailVisible(isVisible) {
      if (!isVisible) {
        this.isSettingVisible = false;
      }
    },
  },
  methods: {
    TogglenfoText() {
      this.showMessage = !this.showMessage;
    },
    setIsMenuOrderSettingVisible(isVisible) {
      this.isMenuOrderSettingVisible = isVisible;
    },
    setBookmarkAddVisibleType(type) {
      this.$emit('set-bookmark-add-visible-type', type);
    },
    setIsBookmarkOrderSettingVisible(isVisible) {
      this.$emit('set-bookmark-order-setting-visible', isVisible);
    },
    toggleIsSettingVisible() {
      this.isSettingVisible = !this.isSettingVisible;
    },
    toggleMenu() {
      this.$emit('toggle-menu', !this.isMenuVisible);
    },
    setMenuDetailVisible(isVisible) {
      this.$emit('set-menu-detail-visible', isVisible);
    },
    setMenuVisible(menuType, isVisible) {
      this.$emit('set-menu-visible', menuType, isVisible);
    },
    setIntranetVisible(bookmarkCategoriesNo, isVisible) {
      this.$emit('set-intranet-visible', bookmarkCategoriesNo, isVisible);
    },
    setBookmarkVisible(bookmarkCategoriesNo, isVisible) {
      this.$emit('set-bookmark-visible', bookmarkCategoriesNo, isVisible);
    },
    setGroupVisible(groupId, isVisible) {
      this.$emit('set-group-visible', groupId, isVisible);
    },
    setMyPlusAppVisible(id, star) {
      this.$emit('set-my-plus-app-visible', id, !star);
    },
    createBookmark(name, url) {
      this.$emit('create-bookmark', name, url);
    },
    modifyBookmark(no, name, url) {
      this.$emit('modify-bookmark', no, name, url);
    },
    removeBookmark(no) {
      this.$emit('remove-bookmark', no);
    },
    modifyBookmarkOrder(noOrderList) {
      this.$emit('modify-bookmark-order', noOrderList);
    },
    modifyMenuOrder(menuTypeList) {
      this.$emit('modify-menu-order', menuTypeList);
    },
    hideMenu() {
      this.$emit('toggle-menu', false);
    },
    clickPlusApp(myPlusApp) {
      this.$emit('click-plus-app', myPlusApp);
    },
    closePlusPrivacyCheckDialog() {
      this.$emit('close-plus-privacy-check-dialog');
    },
    clickAcceptPlusAppPrivacy(selectedPlusApp) {
      this.$emit('click-accept-plus-app-privacy', selectedPlusApp);
    },
    clickIntranet(bookmark) {
      this.$emit('click-intranet', bookmark);
    },
    clickAcceptIntranetBookmarkPrivacy(bookmark) {
      this.$emit('click-accept-intranet-bookmark-privacy', bookmark);
    },
    closeIntranetBookmarkPrivacyCheckDialog() {
      this.$emit('close-intranet-bookmark-privacy-check-dialog');
    },
  },
};
</script>

<style lang="scss" scoped>
.menu-btns {
  //? 요소별 고정값 빼기
  // display: flex;
  // align-items: center;
  // height: 0px;
  // position: absolute;
  // left: 80px;

  .test-office-info {
    display: flex;
    align-items: center;
  }

  .menu-btns-toggle {
    display: flex;
    align-items: center;
    line-height: 38px;
    cursor: pointer;
    padding: 0px 8px;
    &:hover {
      background: #f0f3f6;
      border-radius: 5px;
    }
    .btn-main {
      -webkit-touch-callout: none; /* iOS Safari */
      -webkit-user-select: none; /* Safari */
      -khtml-user-select: none; /* Konqueror HTML */
      -moz-user-select: none; /* Old versions of Firefox */
      -ms-user-select: none; /* Internet Explorer/Edge */
      user-select: none; /* Non-prefixed version, currently
                            supported by Chrome, Edge, Opera and Firefox */
      color: #454545;
      font-size: 18px;
      letter-spacing: -1px;
      font-weight: 500;
      margin-right: 10px;
    }
    .fa-caret-down {
      color: #909090;
      font-size: 18px;
    }
    .fa-caret-up {
      color: #909090;
      font-size: 18px;
    }
    &:hover {
      background: #f0f3f6;
      border-radius: 5px;
    }
  }
  .active {
    background: #f0f3f6;
    border-radius: 5px;
  }

  .gi-exclam-circle {
    color: #d75251;
    cursor: pointer;
  }

  .arrow_box {
    position: relative;
    background: #e6e6e6;
    //height: 42px;
    width: 536px;
    border-radius: 4px;
    font-size: 14px;
    color: #c70909;
    padding: 10px;
    left: 10px;
  }
  .arrow_box:after,
  .arrow_box:before {
    right: 100%;
    top: 50%;
    border: solid transparent;
    content: '';
    height: 0;
    width: 0;
    position: absolute;
    pointer-events: none;
  }

  .arrow_box:after {
    border-color: rgba(136, 183, 213, 0);
    border-right-color: #e6e6e6;
    border-width: 3px;
    margin-top: -3px;
  }
  .arrow_box:before {
    border-color: rgba(245, 245, 245, 0);
    border-right-color: #e6e6e6;
    border-width: 6px;
    margin-top: -6px;
  }
}
</style>
